import NextLink from "next/link";
import React from "react";
import { useRouter } from "next/navigation";
import { DynamicArticleItem, TagItem } from "@/components/PageHome/api/interface";
import { DeviceInfo } from "@/interface/deviceInfo";
import RelatedArticles from "@/components/ArticlePage/Components/RelatedArticles";
import routes from "@/helpers/router";
import styles from "./ArticleAyurveda.module.scss";

interface ArticleAyurvedaProps {
  Title: string;
  Tag?: TagItem;
  articles?: DynamicArticleItem[];
  userAgent: DeviceInfo;
  category?: string;
}

const ArticleAyurveda: React.FC<ArticleAyurvedaProps> = ({
  articles,
  Tag,
  Title,
  userAgent,
  category,
}: ArticleAyurvedaProps) => {
  const tags = [Tag];

  const router = useRouter();

  const handleTagClick: (tag: TagItem) => void = (tag) => {
    // TODO: handle tag click
    router.push(routes.resourcesListing());
  };

  return (
    <section className={`${styles.root} spacingBetweenSections`}>
      <div className={"container"}>
        <RelatedArticles
          items={articles}
          title={Title}
          userAgent={userAgent}
          tags={tags}
          titleClass={styles.title}
          desktopItems={3}
        />
        {!!articles?.length && (
          <div className={styles.viewMore}>
            {/*TODO: add href, PRD does not mention where to take user to (probably  it should go to general article listing) */}
            {/* I’m trying to conceive journey: If the user clicks on this button, then the user will land on the article listing page of Pre-conception category*/}
            {/* My baby is on the way journey: If the user clicks on this button, then the user will land on the article listing page of the particular week of pregnancy*/}
            {/* I’m about to deliver journey: If the user clicks on this button, then the user will land on the article listing page of the particular week of pregnancy*/}
            {/* I’m new mother journey: If the user clicks on this button, then the user will land on the article listing page of the particular month of childhood*/}
            {/* If the child age >12 months: If the user clicks on this button, then the user will land on the article listing page of toddler category*/}
            <NextLink href={routes.resourcesListing("articles", category)} className={styles.link} prefetch={false}>
              View more articles
            </NextLink>
          </div>
        )}
      </div>
    </section>
  );
};

export default ArticleAyurveda;
